/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Flexed } from '../../styles/GlobalComponents';
import { color, lightTheme } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';
import moment from 'moment';
import {
  LP,
  formatUSD,
  formatUSDNoDecimals
} from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';

import { PortfolioItemDisabled } from './PortfolioItemDisabled';

export const PortfolioTradingItem = ({ item }: { item: any }) => {
  const { t } = useTranslation('my_hubs');

  const renderExpiryDate = (date: number) => {
    const d = moment(date);
    const year = d.format('YYYY');
    if (Number(year) > 2100) {
      return 'LIFETIME';
    } else return d.format('DD MMM YYYY');
  };

  const showConvertedHub = (item: any) => {
    if (item?.dateConverted) {
      return (
        <PortfolioItemDisabled
          title={'You Have Converted this Hub NFT into Loyalty Points'}
          subtitle={
            <>
              Date of conversion:{' '}
              {moment.utc(item?.dateConverted).format('MMM DD, yyyy')} <br />{' '}
              Loyalty Points Received: {formatUSD(item?.loyaltyPoints)} {LP}
            </>
          }
        />
      );
    }
  };

  return (
    <>
      <BoxBig relative>
        <HubImage image={item?.product?.imageUrl}>
          <H4 color={color.colors.neutral0}>{item.product?.name}</H4>
        </HubImage>
        <div>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('price')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSDNoDecimals(item.price)} <P3 mb='1'>USDT</P3>
              </P1>
            </Td>

            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_purchase')}
              </CaptionText>
              <P1 bold>{moment(item?.dateOfPurchase).format('DD MMM YYYY')}</P1>
            </Td>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_activation')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {moment(item?.dateOfCreation).format('DD MMM YYYY')}
              </P1>
            </Td>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {/* {t('date_of_purchase')} */}
                DATE OF EXPIRY
              </CaptionText>
              <P1 bold>{renderExpiryDate(item?.expiryDate)}</P1>
            </Td>
          </Tr>
          <div>
            <>
              <Responsive style={{ margin: '24px 0' }} between center>
                <Flexed mbSM='20'>
                  <P3 caps bold color={color.colors.secondary100} mr='60'>
                    ENTRY HUB DETAILS
                  </P3>
                  <P3 flex color={color.colors.secondary100} mr='60'>
                    {t('order_id')}:{' '}
                    <P3 bold ml='2' color={color.colors.secondary100}>
                      {item?.id}
                    </P3>
                  </P3>
                </Flexed>
              </Responsive>
            </>
          </div>
        </div>
        {showConvertedHub(item)}
      </BoxBig>
    </>
  );
};
